import React,{useState} from "react";
import {Modal,Button,Form} from "react-bootstrap";
import { FiImage } from "react-icons/fi";
export default function InsertImageModal({show,handleClose}){

const [file,setFile]=useState(null);
const [url,setUrl]=useState("");

const upload=()=>{
if(file){
console.log("Selected file:",file);
}
if(url){
console.log("Image URL:",url);
}
handleClose();
};

return(

<Modal show={show} onHide={handleClose} centered className="image-modal">

<Modal.Header closeButton>
<Modal.Title>Insert Image</Modal.Title>
</Modal.Header>

<Modal.Body>

<Form.Group className="mb-3">
<Form.Label>Select from files</Form.Label>

<Form.Control
type="file"
onChange={(e)=>setFile(e.target.files[0])}
/>

</Form.Group>

<Form.Group>
<Form.Label>Image URL</Form.Label>

<Form.Control
value={url}
onChange={(e)=>setUrl(e.target.value)}
/>

</Form.Group>

</Modal.Body>

<Modal.Footer>

<Button className="insert-btn" onClick={upload}>
Insert Image
</Button>

</Modal.Footer>

<style>{`

.image-modal .modal-content{
border-radius:8px;
}

.insert-btn{
background:#ff8a5c;
border:none;
padding:8px 18px;
}

`}</style>

</Modal>

);
}